import * as React from "react";
import { X } from "lucide-react";
import { useToast } from "../../hooks/use-toast";

const variantStyles = {
  default: "bg-white border border-slate-200 text-slate-900",
  success: "bg-green-100 border border-green-300 text-green-900",
  error: "bg-red-100 border border-red-300 text-red-900",
  warning: "bg-yellow-100 border border-yellow-300 text-yellow-900",
};

export function Toaster() {
  const { toasts, dismissToast } = useToast();

  React.useEffect(() => {
    const timers = toasts.map((t) =>
      setTimeout(() => dismissToast(t.id), 4000)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts]);

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 w-[300px] max-w-[90vw]">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`relative rounded-lg p-4 shadow-md animate-in slide-in-from-top-5 fade-in ${
            variantStyles[toast.variant || "default"]
          }`}
        >
          <button
            onClick={() => dismissToast(toast.id)}
            className="absolute top-2 right-2 text-slate-500 hover:text-slate-700"
          >
            <X size={16} />
          </button>
          <h4 className="font-semibold text-sm">{toast.title}</h4>
          {toast.description && (
            <p className="text-sm mt-1 text-slate-600">{toast.description}</p>
          )}
        </div>
      ))}
    </div>
  );
}
